<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        title="Opret kopi af sagen"
    >
        <p>En kopi indeholder de samme værdier som originalen.</p>
        <p>Varer med serienummer på sagen vil oprettes som nye blanke serienumre.<br/>Du sendes herefter videre til den nye sag.</p>
        <p><strong>Vælg de produkter der skal med på den nye sag:</strong></p>
        <table class="table is-fullwidth">
            <thead>
            <tr>
                <td></td>
                <td>Type</td>
                <td>Antal</td>
                <td>Fragt</td>
            </tr>
            </thead>
            <tr v-for="item in productLines" :key="item.id" @click="toggleIndex(item.id)" class="is-clickable">
                <td><input type="checkbox" :checked="isSelected(item.id)" /></td>
                <td>{{ item.type }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.no_shipping ? 'Nej' : 'Ja' }}</td>
            </tr>
        </table>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-danger" @click="reset">Fjern markering</button>
                    <button class="button is-default" @click="selectAll">Vælg alle</button>
                    <button class="button is-default" @click="$emit('closed')">Annuller</button>
                    <button class="button is-primary" @click="submit">Opret kopi</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import { FormField, InputCheckbox } from '@elems/form'
import cloneDeep from 'lodash/cloneDeep'

export default {
    components: {
        Modal,
        InputCheckbox,
        FormField,
    },
    props: {
        active: Boolean,
        project: Object,
    },
    data() {
        return {
            indexes: [],
        }
    },
    computed: {
        productLines() {
            if (!this.project.lines) {
                return
            }
            return cloneDeep(this.project.lines).filter(item => item.service_ref === null)
        }
    },
    watch: {
        active() {
            if (this.active) {
                this.selectAll();
            }
        },
    },
    methods: {
        isSelected(index) {
            return this.indexes.indexOf(index) === -1 ? 0 : 1
        },

        toggleIndex(index) {
            const idx = this.indexes.indexOf(index)
            if (idx === -1) {
                this.indexes.push(index)
            } else {
                this.indexes.splice(idx,1)
            }
        },

        reset() {
            this.indexes = [];
        },

        selectAll() {
            this.indexes = [];
            this.productLines.forEach(item => this.indexes.push(item.id))
        },

        submit() {
            axios.post(`/api/projects/${this.$route.params.id}/copy`, { project_lines: this.indexes })
                .then(payload => {
                    this.$router.push({ name: 'project.edit', params: { id: payload.data.newProjectId } });
                    this.$store.dispatch('setSuccess', 'Kopi af sag blev oprettet')
                    this.$emit('closed')
                })
                .catch(error => {
                    console.error(error);
                })
        }
    }
}
</script>
